import React from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  cancelButton: {
    marginRight: '6px',
  },
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: '8px',
      maxWidth: '400px',
    },
  },
  dialogActions: {
    padding: '16px 24px',
  },
  dialogContent: {
    color: '#555555',
    padding: '8px 12px',
  },
  dialogTitle: {
    color: '#172B4D',
    fontWeight: 'bold',
  },
}));

const ConfirmationModal = ({ open, title, message, confirmText, cancelText, onConfirm, onCancel, style, loading = false }) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onCancel}
      aria-labelledby="confirmation-dialog-title"
      aria-describedby="confirmation-dialog-description"
      className={classes.dialog}
      PaperProps={{
        style: {
          ...(style || {}),
          borderRadius: '8px',
          maxWidth: style?.maxWidth || '400px',
          padding: style?.padding || '12px',
        },
      }}>
      <DialogTitle id="confirmation-dialog-title" className={classes.dialogTitle}>
        {title}
      </DialogTitle>

      <DialogContent>
        <DialogContentText id="confirmation-dialog-description" className={classes.dialogContent}>
          {message}
        </DialogContentText>
      </DialogContent>

      <DialogActions className={classes.dialogActions}>
        <Button onClick={onCancel} color="primary" variant="outlined" className={classes.cancelButton} disabled={loading}>
          {cancelText}
        </Button>

        <Button onClick={onConfirm} color="primary" variant="contained" autoFocus disabled={loading}>
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;
